import { DataGridPro } from '@mui/x-data-grid-pro'
import { BOX_SHADOW_ON_WHITE_BG } from 'src/shared/constants/styling-constants'
import styled from 'styled-components'

// Used for DataGrid components on white background

export const DataGridViewEditModeStyled = styled(DataGridPro)<{ $viewMode: boolean }>`
  box-shadow: ${({ $viewMode, theme }) => ($viewMode ? BOX_SHADOW_ON_WHITE_BG.default : theme.shadows[1])};
`
